export const STYLE_MAP = {
  default: {
    backgroundColor: '#f9f9f9'
  },
  colmo: {
    backgroundColor: '#151617'
  },
  diablo: {
    backgroundColor: '#101315'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-board/style.js